var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors)?_c('div',[_c('v-alert',{attrs:{"dense":"","outlined":"","type":"error"}},_vm._l((_vm.errors),function(error,index){return _c('div',{key:index},[_vm._v(_vm._s(error[0]))])}),0)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }